import { v4 as uuidv4 } from "uuid";
import { GroupProps } from "../../utils/functionsInterfaces";
import { displayInfo } from "../../utils/messageToast";

export const handleAddGroup = (
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const newGroup: GroupProps = {
    uuid: uuidv4(),
    id: "",
    name: "",
    type: "group",
    children: [],
    isNew: true,
  };
  setForm((prevForm) => [newGroup, ...prevForm]);
  setButtonSave(true);
  displayInfo("Grupo criado!");
};
